import { Route } from '@angular/router';
import { MainLayoutComponent } from './main-layout/main-layout.component';

import { inject } from '@angular/core';
import { PageNotFoundComponent } from '@features/homepage-components';
import { AuthGuard, tsAuthRoutes } from 'auth';
import { EntitlementsService } from 'entitlements';
import { AdexWrapperComponent } from './app-wrappers/adex.component';
import { DataStudioWrapperComponent } from './app-wrappers/data-studio.component';
import { MeasureStudioWrapperComponent } from './app-wrappers/measure-studio.component';
import { PlatformHomeWrapperComponent } from './app-wrappers/platform-home.component';
import { CentralMainLayoutComponent } from './main-layout/central-main-layout.component';
import { adexRoutes } from './route-categories/adex.routes';
import { centralRoutes } from './route-categories/central.routes';
import { dataStudioRoutes } from './route-categories/data-studio.routes';
import { homeRoutes } from './route-categories/home.routes';
import { measurementStudioRoutes } from './route-categories/measurement-studio.routes';

export const appRoutes: Route[] = [
  ...tsAuthRoutes,
  {
    path: 'central',
    component: CentralMainLayoutComponent,
    children: centralRoutes,
    canActivate: [
      AuthGuard,
      () =>
        inject(EntitlementsService).canActivateWithPermissions({
          requireHubReportsAccess: 'app.central',
          id: 'central',
        }),
    ],
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      //not authenticated pages that need to exist
      // All apps require authentication
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
      },
      {
        path: 'home',
        canActivate: [AuthGuard],
        component: PlatformHomeWrapperComponent,
        children: homeRoutes,
      },
      {
        path: 'adex',
        canActivate: [
          AuthGuard,
          () =>
            inject(EntitlementsService).canActivateWithPermissions({
              requireAdexMarketer: true,
            }),
        ],
        component: AdexWrapperComponent,
        children: adexRoutes,
      },
      {
        path: 'data-studio',
        canActivate: [
          AuthGuard,
          () =>
            inject(EntitlementsService).canActivateWithPermissions(
              {
                requireNotLimitedView: true,
                id: 'data-studio',
              },
              ['home'],
            ),
        ],
        component: DataStudioWrapperComponent,
        children: dataStudioRoutes,
      },
      {
        path: 'measure-studio',
        canActivate: [
          AuthGuard,
          () =>
            inject(EntitlementsService).canActivateWithPermissions(
              {
                requireNotLimitedView: true,
                id: 'measure-studio',
              },
              ['home'],
            ),
        ],
        component: MeasureStudioWrapperComponent,
        children: measurementStudioRoutes,
      },
      {
        path: 'community',
        component: PageNotFoundComponent,
        data: {
          resourceName: 'community',
        },
      },
      {
        path: 'helpcenter',
        component: PageNotFoundComponent,
        data: {
          resourceName: 'helpcenter',
        },
      },
    ],
  },
  /** Date deletion does not need someone to be logged in. Anyone can use this page. */
  {
    path: 'data-deletion-request',
    loadChildren: () =>
      import('data-deletion-request').then((m) => m.DataDeletionRequestModule),
  },
  {
    path: '**',
    pathMatch: 'full',
    component: PageNotFoundComponent,
    data: {
      title: '404 Page Not Found',
      tabTitle: 'Page Not Found - DemandScience',
    },
  },
];
